<template>
  <div v-if="loading" class="loading">
      <div class="loader">
        <div class="center"></div>
        <div class="outer"><span></span><span></span></div>
        <div class="inner"></div>
      </div>
  </div>
</template>

<script>
  import VueScrollTo from 'vue-scrollto';
  import { store } from '@/global.js';
  export default {
    name: 'Loading',
    store,
    data() {
      return {
        loading: false,
      }
    },
    created() {
      //this.loading = this.$store.getters.loading;
    },
    watch: {
      '$store.state.loading': function (val) {
       // this.loading = val;
        let f = this;
        if(val === true) {
      //    setTimeout(function(){
         //   f.loading = false;
            f.$store.commit('change', false);
            let offsetHeight = -($(window).height() / 2);
            VueScrollTo.scrollTo('.p-content', 1000, {offset:offsetHeight});
        //  }, 1000);
        }
      }
    },

    methods: {
      on() {
        loading = true;
      },
      off() {
        loading = off;
      }
    },
  }

</script>
